// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","grid":"footer_grid__T8FVW","col":"footer_col__bjlnP","formContainer":"footer_formContainer__ED6jf"};